import React, {useState} from 'react';
import './CreateUserForm.css';
import {useForm} from "@mantine/form";
import {TextInput, Button, Grid, Select} from "@mantine/core";
import axios from "axios";
import showNotification from "../../../utils/showNotification";

function CreateUserForm({updateData, setUpdateData, setOpen}) {
    const [loading, setLoading] = useState(false);
    const form = useForm({
        initialValues: {
            type: "teacher",
            name: "",
            lastname: "",
            profilePicture: "",
            email: "",
            phone: "+5493513333333",
            sendMail: "false"
        },
        validate: {},
    });
    const handleSubmit = async (values) => {
        setLoading(true)

        const data = {
            data: {...values}
        }
        axios.post(`${process.env.REACT_APP_BACKEND_SERVER}/users/createUser`, data)
            .then((res) => {
                if (res.status === 200) {
                    setUpdateData(!updateData)
                    setOpen(false)
                } else {
                    showNotification({
                        color: "red",
                        status: "error",
                        title: "Error",
                        message: `Error al crear el usuario`,
                    });
                }
            })
            .catch((err) => {
                console.log(err)
                const error = err.message || err.response.data.message || err || "Error al crear el usuario";
                showNotification({
                    color: "red",
                    status: "error",
                    title: "Error",
                    message: `Error al crear el usuario: ${error}`,
                });
            })
            .finally(() => {
                setLoading(false)
            })
    }


    return (
        <div className="createUser__container">
            <h2 className="createUser__title">Crear usuario</h2>
            <form
                onSubmit={form.onSubmit((values) => handleSubmit(values))}
                className="createUser__form"
            >
                <Grid style={{width: "100%"}}>
                    <Grid.Col span={12}>
                        <Select
                            {...form.getInputProps('type')}
                            withAsterisk
                            label="Tipo de usuario"
                            data={[
                                {value: "teacher", label: "Profesor"},
                                {value: "student", label: "Estudiante"},
                                {value: "staff", label: "Staff"},
                            ]}
                        />
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <TextInput
                            {...form.getInputProps('name')}
                            withAsterisk
                            label="Nombre"
                        />
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <TextInput
                            {...form.getInputProps('lastname')}
                            withAsterisk
                            label="Apellido"
                        />
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <TextInput
                            {...form.getInputProps('profilePicture')}
                            withAsterisk
                            label="URL de la foto de perfil"
                        />
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <TextInput
                            {...form.getInputProps('email')}
                            withAsterisk
                            label="Email"
                        />
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <TextInput
                            {...form.getInputProps('phone')}
                            withAsterisk
                            label="Teléfono"
                            placeholder="+5493513333333"
                        />
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <Select
                            {...form.getInputProps('sendMail')}
                            withAsterisk
                            label="Notificar por email"
                            description="Se enviará un email de validación de email de todos modos"
                            data={[
                                {value: "true", label: "Si"},
                                {value: "false", label: "No"},
                            ]}
                        />
                    </Grid.Col>
                </Grid>
                <Button type="submit" className="createUser__button" loading={loading}>Crear usuario</Button>
            </form>
        </div>
    );
}

export default CreateUserForm;